var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadimages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#36A41D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.535 13.2128H12.4613C12.0616 13.2128 11.6975 13.3758 11.4315 13.6406H11.4303V13.6431H11.4291C11.1643 13.9103 11 14.2757 11 14.6765V24.7817C11 25.185 11.1643 25.5503 11.4291 25.8164C11.6939 26.0812 12.0604 26.2454 12.4637 26.2454H27.5375C27.9408 26.2454 28.3061 26.0812 28.5709 25.8164C28.8357 25.5516 29 25.185 29 24.7829V14.6778C29 14.2744 28.8357 13.9079 28.5709 13.6443C28.3061 13.3795 27.9396 13.2153 27.5375 13.2153L27.535 13.2128ZM12.2602 14.4779L12.2627 14.4755C12.3129 14.4252 12.3828 14.3946 12.4613 14.3946H27.535C27.6123 14.3946 27.6822 14.4264 27.7336 14.4779C27.7851 14.5294 27.817 14.5993 27.817 14.6765V20.6921L24.8246 17.6861C24.5953 17.4557 24.2214 17.4544 23.9909 17.6837L23.9885 17.6861L19.368 22.3262L16.2567 19.2026C16.0274 18.9721 15.6535 18.9709 15.4231 19.2001L15.4206 19.2026L12.1793 22.4574V14.6765C12.1793 14.5981 12.21 14.5282 12.2602 14.4779ZM12.4613 25.0624C12.3841 25.0624 12.3142 25.0305 12.2627 24.9791C12.2124 24.9288 12.183 24.8601 12.1818 24.7854C12.1818 24.7841 12.1793 24.7829 12.1793 24.7805V24.1258L15.8387 20.4518L18.95 23.5754L20.4297 25.0624H12.4613ZM22.0932 25.0624L21.7439 24.7118L20.198 23.1598L24.4041 18.9366L27.8146 22.3617V24.7817C27.8146 24.7817 27.8121 24.7841 27.8121 24.7866C27.8109 24.8614 27.7815 24.93 27.7312 24.9803C27.6797 25.0318 27.6098 25.0636 27.5326 25.0636H22.0908L22.0932 25.0624Z",
    fill: "#36A41D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3371 19C21.0759 19 21.6741 18.4018 21.6741 17.663C21.6741 16.9241 21.0759 16.3259 20.3371 16.3259C19.5982 16.3259 19 16.9241 19 17.663C19 18.4018 19.5982 19 20.3371 19Z",
    fill: "#36A41D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadimages);
export default __webpack_public_path__ + "static/media/uploadimages.64926f5a70da74551e2636526eef19f7.svg";
export { ForwardRef as ReactComponent };